import { Card, Icons, Typography } from '@pankod/refine-antd';
import { downloadCSVFile } from 'utilities/file';
import styles from './DownloadCsvTemplateCard.module.css';

interface DownloadCsvTemplateCardProps {
  rows: string[][];
  title: string;
  hideTextWhenSidebarOpenOnMobile?: boolean;
}

const { Text } = Typography;

export const DownloadCsvTemplateCard: React.FC<DownloadCsvTemplateCardProps> = (props) => {
  const onFileDownloadClick = () => {
    downloadCSVFile(props.rows);
  };

  return (
    <Card
      className={`${styles.card} ${
        props.hideTextWhenSidebarOpenOnMobile
          ? styles['card--hide-text-on-sidebar-open-mobile']
          : ''
      }`}
      onClick={onFileDownloadClick}
    >
      <div className={styles['card__item']}>
        <span>
          <Icons.FileOutlined className={styles['card__icon']} />
        </span>
        <span>
          <Icons.DownloadOutlined className={styles['card__icon']} />
        </span>
      </div>
      <Text className={styles['card__text']}>{props.title}</Text>
    </Card>
  );
};
